import type { ChatMessageAttachment } from './types'

export function normaliseMessage(text: string): string {
  return text
    .replace(/(\n\s*){2,}/g, '\n\n')
    .trim()
}

export const fileToChatMessageAttachment = (file: File): Promise<ChatMessageAttachment> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => {
      if (typeof reader.result !== 'string') {
        reject(new Error('Failed to read file'))
        return
      }

      resolve({
        filename: file.name,
        dataUrl: reader.result,
        mimeType: file.type,
      })
    }

    reader.onerror = () => reject(reader.error ?? new Error('Failed to read file'))
    reader.readAsDataURL(file)
  })
